import { render, staticRenderFns } from "./ImgModal.vue?vue&type=template&id=2f4c6f11"
import script from "./ImgModal.vue?vue&type=script&lang=js"
export * from "./ImgModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports